import React, { Component } from 'react';
import HomeBody from './mycomponents/homebody';
import Navbar from './mycomponents/navbar';
import PalmeeupIcon from './mycomponents/palmeeupbuttonicon';

class Home extends Component {
    state = {  } 
    render() { 
        return (
            <React.Fragment>
                {/* <PalmeeupIcon/> */}
            <Navbar/>
            <HomeBody/>
            </React.Fragment>
        );
    }
}
 
export default Home;


